/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

/**
 * Dialog sizes
 */
export enum DIALOG_CONTENT_ALIGN {
	LEFT = "left",
	CENTER = "center",
	RIGHT = "right",
	STRETCH = "stretch"
}

/**
 * Dialog flow direction
 */
export enum DIALOG_CONTENT_FLOW {
	COLUMN = "column",
	ROW = "row"
}

/**
 * Component props
 */
export interface IDialogContentProps {
	align?: DIALOG_CONTENT_ALIGN;
	flow?: DIALOG_CONTENT_FLOW;
	className?: string;
}

/**
 * Dialog Content
 * Padded and aligned content.
 *
 * @param props Component props
 */
export const DialogContent: FC<IDialogContentProps> = ({ align, flow, children, className }) => {
	const baseClass = BEM("edt-dialog", "content");
	baseClass.mod("align-" + (align || DIALOG_CONTENT_ALIGN.CENTER));
	baseClass.mod("flow-" + (flow || DIALOG_CONTENT_FLOW.COLUMN));

	if (className) {
		baseClass.mod(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
